'use strict';

var GlobalNotificationsDataService = function GlobalNotificationsDataService(dataRetrieverService, dataRetrieverConstantsService, featureToggleService) {
  function getData() {
    return dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.ALL_SCREENS, dataRetrieverConstantsService.GLOBAL_NOTIFICATIONS_MODE).retrieveSimpleData(dataRetrieverConstantsService.GLOBAL_NOTIFICATIONS_MODE, undefined);
  }
  function getTotalAlertsNumber() {
    return getData().then(function (result) {
      if (featureToggleService.isEnabled('NPS_HOST_SHARE')) {
        return result.domain.length;
      } else {
        return 0;
      }
    });
  }
  return {
    getData: getData,
    getTotalAlertsNumber: getTotalAlertsNumber
  };
};
GlobalNotificationsDataService.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService', 'FeatureToggleService'];
module.exports = GlobalNotificationsDataService;